// @ts-nocheck

import PropTypes from 'prop-types';
import React from 'react';
import { LoadingSkeleton } from 'sonata-react-components';

function ReportingInsightsSkeleton({ hasChart }) {
  if (hasChart) {
    return (
      <div className="reportingInsightsSkeleton">
        <LoadingSkeleton circle height={150} width={150} />
        <LoadingSkeleton count={5} delay={2} duration={2} height="30px" width="100%" />
      </div>
    );
  }
  return <LoadingSkeleton count={6} delay={2} duration={2} height="30px" width="100%" />;
}

ReportingInsightsSkeleton.propTypes = {
  hasChart: PropTypes.bool
};

export default ReportingInsightsSkeleton;
